angular.module('qkr')
    .controller('KeysController', KeysController);

function KeysController($location, $routeSegment, utils, keyService, gettextCatalog) {
    const vm = this;

    vm.keys = {};
    vm.createKey = false;
    vm.newLabel = '';
    vm.newPassword = '';

    vm.list = function() {
        keyService.listKeys().then((data) => {
            vm.keys = data;
        });
    };

    vm.createNew = function(keysForm) {
        if (vm.newLabel !== '' && vm.newPassword !== '' && vm.newMode !== '') {
            vm.errors = null;
            keyService.createKey({label: vm.newLabel, password: vm.newPassword})
                .then(({id, secretKey, label} = {}) => {
                    //Cleaning form fields
                    keyService.invalidateCache = true;
                    vm.list();
                    vm.newLabel = '';
                    vm.newPassword = '';
                    vm.createKey = false;

                    utils.downloadBase64(secretKey, `${label}.p12`);

                    // redirecting to Certificate Info
                    return $location.path($routeSegment.getSegmentUrl('key', {keyId:id}));
                }).catch(response => {
                    if ((((response.data || {}).errors || [])[0] || {}).field === 'label') {
                        vm.errors = {
                            label: gettextCatalog.getString('Already exists for partner')
                        };
                    }
                });
        }
    };

    vm.cancelCreate = function() {
        vm.errors = null;
        vm.newLabel = '';
        vm.newPassword = '';
        vm.createKey = false;
    };

    vm.list();
}



// WEBPACK FOOTER //
// ./src/controllers/mastercard/keys.controller.js